import React, { useContext, useState, useEffect } from 'react'
import Button from './button';
import Button1 from "./Button1";
import FavoritesContext from '../../contexts/favorites-course';
//import Article from "../Course/Article";

function Card3Items(props) {
    const favoritesCtx = useContext(FavoritesContext);
    const itemIsFavorite = favoritesCtx.itemIsFavorite(props.id);

    function toggleFavoriteStatusHandler() {
        if (itemIsFavorite) {
            favoritesCtx.removeFavorite(props.id);
        } else {
            favoritesCtx.addFavorite({
                id: props.id,
                title: props.title,
                image: props.image,
                desctiption: props.desctiption,
                desctiption1: props.desctiption1
            })
        }
    }

    const mettupsStorage = localStorage.getItem("meetups");
    let mettupsData = JSON.parse(mettupsStorage);
    const [meetupsId, setMeetupsId] = useState();

    if (mettupsData) {

        const found = mettupsData.filter(element => element.id === props.id);
        // 




    }

    //console.log("meetupsId", meetupsId);
    return (
        <div className="col-md-4 col-sm-6 col-xs-12 card">
            <div className="card__image-container">
                <img className="card__image" src={props.image} alt={props.title} />
            </div>
            <svg className="card__svg" viewBox="0 0 800 500">

                <path d="M 0 100 Q 50 200 100 250 Q 250 400 350 300 C 400 250 550 150 650 300 Q 750 450 800 400 L 800 500 L 0 500" stroke="transparent" fill="#333" />
                <path className="card__line" d="M 0 100 Q 50 200 100 250 Q 250 400 350 300 C 400 250 550 150 650 300 Q 750 450 800 400" stroke="pink" stroke-width="3" fill="transparent" />
            </svg>

            <div className="card__content">
                <h2 className="card__title">{props.title} </h2>
                <p style={{ height: "5em" }} > {props.desctiption1} </p>
                <Button idArticle={props.id} />
                <Button1


                    idArticle={props.id}
                    itemIsFavorite={itemIsFavorite}
                    toggleFavoriteStatusHandler={toggleFavoriteStatusHandler} />
            </div>
        </div>
    )
}

export default Card3Items